import { render } from "./LogHistory.vue?vue&type=template&id=4abfe0ae&scoped=true"
import script from "./LogHistory.vue?vue&type=script&lang=js"
export * from "./LogHistory.vue?vue&type=script&lang=js"

import "./LogHistory.vue?vue&type=style&index=0&id=4abfe0ae&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abfe0ae"]])

export default __exports__